import { Flp360Status } from "../enums/flp360-status.enum";

export class Flp360StatusConstants {
    public static statusConstants = [
        { value: Flp360Status.ACTIVE, name: 'Active' },
        { value: Flp360Status.CANCELLED, name: 'Cancelled' },
        { value: Flp360Status.NO_SUBSCRIPTION, name: 'No Subscription' },
        { value: Flp360Status.RESTRICTED, name: 'Restricted' },
    ];
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/flp360-status.constants.ts